(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@pakhshkit-js/pakhshkit-js"), require("shaka-player"));
	else if(typeof define === 'function' && define.amd)
		define("dash", ["pakhshkit-js", "shaka-player"], factory);
	else if(typeof exports === 'object')
		exports["dash"] = factory(require("@pakhshkit-js/pakhshkit-js"), require("shaka-player"));
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["dash"] = factory(root["pakhshkit"]["core"], root["shaka"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// dash/webpack/universalModuleDefinition